import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
  import { Injectable } from '@angular/core';
  import { Observable } from 'rxjs';
  import { UserService } from 'src/services/user.service';
  import { HEADER_KEYS } from 'src/shared/constants';
  
  @Injectable()
  export class XssInterceptor implements HttpInterceptor {
    constructor(private userService: UserService) {}
    intercept(
      req: HttpRequest<any>,
      next: HttpHandler,
    ): Observable<HttpEvent<any>> {
      const xsrfToken = this.userService.XsrfToken;
  
      if (xsrfToken) {
        req = req.clone({
          setHeaders: {
            [HEADER_KEYS.xsrfToken]: xsrfToken,
          },
        });
      }
  
      return next.handle(req);
    }
  }